import { DEVICE_TYPE } from "@/enums/device-type"
import { useEffect } from "react"
import { Route, Routes } from "react-router-dom"
import ServerPanel from "./server-panel"
import DataBoxPanel from "./data-box"
import SensorPanel from "./sensor"

export default function DeviceTabMainPage(second) {


    return (
        <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
            <Routes>
                {/* 服务器 */}
                <Route path={`:deviceId/${DEVICE_TYPE.SERVER}`} element={<ServerPanel />} />
                {/* 采集箱 */}
                <Route path={`:deviceId/${DEVICE_TYPE.DATA_BOX}`} element={<DataBoxPanel />} />
                {/* 传感器 */}
                <Route path={`:deviceId/${DEVICE_TYPE.SENSOR}`} element={<SensorPanel />} />
            </Routes>
        </div>
    )
}